<template>
  <div class="ts-p-3">
    <div class="ts-overflow-y-scroll max-h">
      <table class="ts-w-full">
        <thead>
          <tr>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.barcode') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2"
              style="width: 15%"
            >
              {{ $t('purchaseOrder.name') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.uom') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.quantity') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.cost') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.discount') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.disType') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.amount') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.maxReorder') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
              style="width: 10%"
            >
              {{ $t('purchaseOrder.alloworder') }}
            </th>
            <th
              class="ts-uppercase ts-border-gray-300 ts-border ts-whitespace-no-wrap ts-py-2 ts-px-3 ts-text-center"
              style="width: 3%"
            >
              <a href="#" class="ts-text-white" @click.prevent="addNewRow">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(d, index) in model.po_detail" :key="index">
            <td style="width: 10%">
              <input
                type="text"
                class="form-control"
                style="min-width: 90px"
                :value="findProduct(d.product_id).barcode"
                readonly
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.product_id')"
              >
                {{ errors.first('po_detail.' + index + '.product_id') }}
              </div>
            </td>
            <td class="ts-p-2" style="width: 20%">
              <input
                type="text"
                :value="findProduct(d.product_id).product_name_en"
                class="form-control"
                readonly
                style="min-width: 300px"
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.product_id')"
              >
                {{ errors.first('po_detail.' + index + '.product_id') }}
              </div>
            </td>
            <td style="width: 10%">
              <a-select
                v-model="d.uom_id"
                class="ts-w-full"
                style="min-width: 70px"
                :class="{
                  'is-invalid': errors.has('po_detail.' + index + '.uom_id')
                }"
                @change="onUomChange(d)"
              >
                <a-select-option
                  v-for="(u, uIndex) in getUom(d.uom_cat_id)"
                  :key="uIndex"
                  :value="u.value"
                  >{{ u.label }}
                </a-select-option>
              </a-select>
              <div
                class="invalid-feedback"
                v-if="errors.has('po_detail.' + index + '.uom_id')"
              >
                {{ errors.first('po_detail.' + index + '.uom_id') }}
              </div>
            </td>
            <td style="width: 5%">
              <input
                v-model.number="d.qty"
                type="number"
                ref="qty"
                @input="calculate(d)"
                class="form-control ts-text-center"
                :class="{
                  'is-invalid': errors.has('po_detail.' + index + '.qty')
                }"
                style="min-width: 70px"
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.qty')"
              >
                {{ errors.first('po_detail.' + index + '.qty') }}
              </div>
            </td>
            <td style="width: 5%">
              <ts-currency-input
                v-model.number="d.cost"
                @input="calculate(d)"
                class="form-control ts-text-right"
                style="min-width: 100px"
                :currency="default_currency_sign"
                :precision="default_precision"
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.cost')"
              >
                {{ errors.first('po_detail.' + index + '.cost') }}
              </div>
            </td>
            <td>
              <input
                ref="discountRate"
                v-model.number="d.discount_rate"
                @input="calculate(d)"
                type="number"
                class="form-control"
                :class="{
                  'is-invalid': errors.has(
                    'po_detail.' + index + '.discount_rate'
                  )
                }"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('po_detail.' + index + '.discount_rate')"
              >
                {{ errors.first('po_detail.' + index + '.discount_rate') }}
              </div>
            </td>
            <td style="width: 100px">
              <a-select
                v-model="d.discount_type"
                class="ts-w-full"
                style="min-width: 100px"
                :class="{
                  'is-invalid': errors.has('po_detail.' + index + '.uom_id')
                }"
                @change="calculate(d)"
              >
                <a-select-option value="%">%</a-select-option>
                <a-select-option :value="default_currency_sign">{{
                  default_currency_sign
                }}</a-select-option>
              </a-select>
              <div
                class="invalid-feedback"
                v-if="errors.has('po_detail.' + index + '.discount_type')"
              >
                {{ errors.first('po_detail.' + index + '.discount_type') }}
              </div>
            </td>
            <td style="width: 10%">
              <ts-currency-input
                v-model.number="d.total_after_discount"
                class="form-control ts-text-right"
                style="min-width: 100px"
                :currency="default_currency_sign"
                :precision="default_precision"
              />
              <div
                class="validate"
                v-if="
                  errors.has('po_detail.' + index + '.total_after_discount')
                "
              >
                {{
                  errors.first('po_detail.' + index + '.total_after_discount')
                }}
              </div>
            </td>
            <td style="width: 3%">
              <input
                type="text"
                class="form-control ts-text-center"
                style="min-width: 90px"
                v-model="d.maximum_reorder_allow"
                readonly
              />
              <div
                class="validate"
                v-if="
                  errors.has('po_detail.' + index + '.maximum_reorder_allow')
                "
              >
                {{
                  errors.first('po_detail.' + index + '.maximum_reorder_allow')
                }}
              </div>
            </td>
            <td style="width: 1%" class="ts-text-center">
              <input type="checkbox" v-model="d.alloworder" />
            </td>
            <td style="width: 1%" class="ts-text-center">
              <a
                href="#"
                class="ts-text-red-700 hover:ts-text-red-700"
                @click.prevent="removeItem(index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
          <tr>
            <td class="ts-text-left ts-text-red-700">
              <p class="ts-font-extrabold">
                {{ $t('purchaseOrder.numberRow') + ': ' }}
                <span class="ts-font-extrabold">{{
                  model.po_detail.length
                }}</span>
              </p>
            </td>
            <td colspan="2" class="ts-text-right ts-text-red-700">
              <p class="ts-font-extrabold">{{ $t('purchaseOrder.total') }} :</p>
            </td>
            <td class="ts-text-center ts-text-red-700 ts-px-3">
              <p class="ts-font-extrabold" style="padding: 0 27px 0 13px">
                {{ $formatNumber(sumTotalQty) }}
              </p>
            </td>
            <td class="ts-text-right ts-text-red-700">
              <p class="ts-font-extrabold" style="padding: 0 13px">
                {{ $defaultCurrencyWithCode(sumCost, default_precision) }}
              </p>
            </td>
            <td colspan="2"></td>
            <td class="ts-text-right ts-text-red-700">
              <p class="ts-font-extrabold" style="padding: 0 13px">
                {{
                  $defaultCurrencyWithCode(
                    sumTotalAfterDiscount,
                    default_precision
                  )
                }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- modal show pop-up to be able add product -->
      <a-modal
        v-if="show_modal_add_product"
        v-model="show_modal_add_product"
        :footer="null"
        :zIndex="1020"
        :maskClosable="false"
        width="800px"
        :title="$t('stockIn.product')"
      >
        <ProductList v-model="model" />
      </a-modal>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapGetters } from 'vuex'
import ProductList from './product-list.vue'

export default {
  name: 'purchaseOrderItem',
  components: {
    ProductList
  },
  props: ['value', 'validate'],
  data () {
    return {
      errors: new Errors(),
      show_modal_add_product: false,
      model: {},
      newRow: {
        product_id: null,
        uom_id: null,
        uom_cat_id: null,
        qty: 1,
        maximum_reorder_allow: 0,
        alloworder: false,
        cost: 0,
        discount_rate: 0,
        discount_type: '%',
        total_after_discount: 0
      }
    }
  },
  computed: {
    ...mapGetters('purchaseOrder/order', [
      'getProduct',
      'getUom',
      'findProduct',
      'getCostPrice'
    ]),
    sumTotalAfterDiscount () {
      return _.round(
        _.sumBy(this.model.po_detail, 'total_after_discount'),
        this.default_precision
      )
    },
    sumTotalQty () {
      return _.sumBy(this.model.po_detail, 'qty')
    },
    sumCost () {
      return _.round(
        _.sumBy(this.model.po_detail, 'cost'),
        this.default_precision
      )
    },
    default_currency_sign () {
      return this.$store.state.authUser.sys_setting.default_currency_sign
    },
    default_precision () {
      return this.$store.state.authUser.sys_setting.decimal_digit
    }
  },
  created () {
    this.model = this.value
  },
  methods: {
    addNewRow () {
      this.show_modal_add_product = true
    },
    addItem () {
      this.model.po_detail.push(_.clone(this.newRow))
    },
    removeItem (index) {
      this.model.po_detail.splice(index, 1)
    },
    productChange (options, row) {
      row.uom_id = options.data.props.uom_id
      row.uom_cat_id = options.data.props.uom_cat_id
    },
    onUomChange (row) {
      row.cost = this.getCostPrice({
        product_id: row.product_id,
        uom_id: row.uom_id
      })
      this.calculate(row)
    },
    calculate (row) {
      if (row.discount_type == '%') {
        row.cost = _.round(row.cost, this.default_precision)
        let discount = _.round(
          row.cost * row.qty * (row.discount_rate / 100),
          2
        )
        row.total_after_discount = _.round(
          row.cost * row.qty - discount,
          this.default_precision
        )
      } else {
        row.total_after_discount = _.round(
          row.cost * row.qty - row.discount_rate,
          this.default_precision
        )
      }
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.py {
  padding: 0.45rem 0;
}
.max-h {
  min-height: 30vh;
  max-height: 50vh;
}
table thead tr th {
  padding: 4px 5px;
  z-index: 3;
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
  background-color: rgb(22, 102, 145);
  color: white;
}

table tbody tr td {
  padding: 4px 5px;
}
table {
  position: relative;
  border-collapse: collapse;
}
</style>
